import LandingPage from '@/pages/landing'
import ProjectList from '@/pages/projectList'
import { useAuth0 } from '@auth0/auth0-react'
import { LoadingPage } from '@infraloop/common'
import { useTranslation } from '@infraloop/i18n'

/**
 * The application root. Signed-in users get the project dashboard here — the address every
 * distributed link and the editor's back button points at, so it stays put — while visitors
 * get the public landing page rather than being sent straight to the Auth0 login screen.
 */
const Home = () => {
  // Hooks
  const { t } = useTranslation()
  const { isLoading, isAuthenticated } = useAuth0()

  // Auth0 is still settling — including the token exchange it runs when it redirects back
  // here after a login — so which of the two pages belongs here isn't known yet.
  if (isLoading) return <LoadingPage text={t('ui.loading')} />

  return isAuthenticated ? <ProjectList /> : <LandingPage />
}

export default Home
